import { ContactResponse } from 'generated/api-client';
import { ProContactDeleteConfirmModalQuery } from 'generated/graphql';
import React, { FunctionComponent } from 'react';
import { Button, Modal } from 'semantic-ui-react';

export type ProContactDeleteConfirmModalProps = {
  open: boolean;
  onClose?: () => void;
};

type ProContactDeleteConfirmModalViewProps =
  ProContactDeleteConfirmModalProps & {
    contact: ContactResponse;
    relatedProViewProContacts: ProContactDeleteConfirmModalQuery['relatedProViewProPeople'];
    relatedProViewAccounts: ProContactDeleteConfirmModalQuery['relatedProViewAccounts'];
    hasCurrentAccountRelated: boolean;
    confirmDelete: () => void;
  };

const ProContactDeleteConfirmModalView: FunctionComponent<
  ProContactDeleteConfirmModalViewProps
> = ({
  contact,
  relatedProViewProContacts,
  relatedProViewAccounts,
  hasCurrentAccountRelated,
  open,
  onClose,
  confirmDelete,
}) => (
  <Modal
    onClose={onClose}
    open={open}
    closeOnDimmerClick={false}
    closeOnEscape={false}
    closeIcon
  >
    <Modal.Header>
      Suppression du contact : {contact.givenName} {contact.familyName}
    </Modal.Header>
    <Modal.Content>
      {relatedProViewProContacts && relatedProViewProContacts.length > 0 ? (
        <>
          <p>
            Ce <b>contact</b> est utilisé par <b>d&apos;autres fiches</b> :
          </p>
          <ul>
            {relatedProViewProContacts.map((proView) => (
              <li key={`related-pro-view-${proView.id}`}>
                <a
                  href={`/pros/update/${proView.id}/zone`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {proView.proPresentation.name} -{' '}
                  {proView.proPresentation.mainTradeNames} -{' '}
                  {proView.bilikZone.mainCityCode}
                </a>
              </li>
            ))}
          </ul>
        </>
      ) : null}
      {relatedProViewAccounts && relatedProViewAccounts.length > 0 ? (
        <>
          <p>
            <b>L&apos;adresse email</b> ({contact.email}) du contact est
            utilisée comme accès à{' '}
            <b>l&apos; espace pro sur d&apos;autres fiches</b> :
          </p>
          <ul>
            {relatedProViewAccounts.map((proView) => (
              <li key={`related-account-${proView.id}`}>
                <a
                  href={`/pros/update/${proView.id}/zone`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {proView.proPresentation.name} -{' '}
                  {proView.proPresentation.mainTradeNames} -{' '}
                  {proView.bilikZone.mainCityCode}
                </a>
              </li>
            ))}
          </ul>
        </>
      ) : null}
      <p>
        <b>
          Pense donc à mettre à jour les fiches si nécessaire !
          {hasCurrentAccountRelated ? (
            <>
              <br />
              Pense aussi à supprimer l&apos;accès à l&apos;espace pro :
              {contact.email} de cette fiche !
            </>
          ) : null}
        </b>
      </p>
    </Modal.Content>
    <Modal.Actions>
      <Button
        onClick={(): void => {
          if (onClose) {
            onClose();
          }
        }}
      >
        Annuler
      </Button>
      <Button negative onClick={confirmDelete}>
        Supprimer
      </Button>
    </Modal.Actions>
  </Modal>
);

export default ProContactDeleteConfirmModalView;
